import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { activityQueryKeys } from "./activityQueryKeys";

export const useMutationDeleteActivity = ({ api }: { api: ApiType }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (activityId: number) =>
      await api.activityApi.delete(activityId),
    onSuccess: async () =>
      await queryClient.invalidateQueries({
        queryKey: activityQueryKeys.all(),
      }),
  });
};
